import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const MntnSessionSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  user: z.object({
    id: z.string(),
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
    org: z
      .object({
        slug: z.string().optional(),
      })
      .optional(),
    profileImageUrl: z.string().nullable().optional(),
  }),
})

export type MntnSession = ZodInfer<typeof MntnSessionSchema>
